<template>
  <div id="app">
    <div
        class="zoomable-div"
        :style="{ transform: `scale(${scale})` }"
        @wheel="zoom($event)"
    >
      <!-- 缩放的内容 -->
      缩放我
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scale: 1, // 初始缩放比例为1
    };
  },
  methods: {
    zoom(event) {
      // 通过滚轮事件的deltaY判断缩放方向
      const delta = event.deltaY > 0 ? 1.1 : 0.9;
      this.scale = this.scale * delta;
    },
  },
};
</script>

<style>
.zoomable-div {
  width: 200px;
  height: 200px;
  overflow: hidden;
  transition: transform 0.1s; /* 添加过渡动画 */
}
</style>